module.exports = __webpack_public_path__ + "static/media/desk-icon.f9c298a9.svg";